import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';

export const Logo = props => {
  const { sx, url } = props;
  const navigate = useNavigate();

  return (
    <Box
      onClick={() => url ? window.location.assign(url) : navigate('/')}
      component="img"
      src="/static/logo-mohikan.png"
      sx={{ cursor: 'pointer', width: 250, height: 125, ...sx, objectFit: 'contain' }} />
  );
};
Logo.propTypes = {
  sx: PropTypes.object
};
